import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VotanteService {

  apiUrl: string = environment.REST_API.URL;
  constructor(private http: HttpClient) { }

  guardar(votante) {
    return this.http.post(this.apiUrl + "votante/guardarVotante", votante);
  }

  actualizar(votante) {
    return this.http.put(this.apiUrl + "votante/actualizarVotante", votante);
  }

  obtenerPagina(page: number, size: number, idVotacion: number) {
    return this.http.get(this.apiUrl + "votante/obtenerVotantes?page=" + page + "&size=" + size + "&idVotacion=" + idVotacion);
  }

  obtenerPaginaLink(link) {
    return this.http.get(link);
  }

  eliminarPorId(idVotante: number) {
    return this.http.delete(this.apiUrl + "votante/eliminarVotante?idVotante=" + idVotante);
  }

  eliminarPorIdVotacion(idVotacion: number) {
    return this.http.delete(this.apiUrl + "votante/eliminarVotantesVotacion?idVotacion=" + idVotacion);
  }

  obtenerVotacionTokenUsuario(token: string, usuario: string) {
    return this.http.get(this.apiUrl + "votante/obtenerVotacionTokenUsuario?token=" + token + "&nombreUsuario=" + usuario);
  }

  emitirVoto(voto) {
    return this.http.post(this.apiUrl + "voto/guardarVoto", voto);
  }

  obtenerPaginaVotantes(page: number, size: number, token: string, correoElectronico: string) {
    return this.http.get(this.apiUrl + "votante/obtenerVotantesParticipantesPaginado?page=" + page + "&size=" + size + "&token=" + token + "&correoElectronico=" + correoElectronico);
  }

  obtenerPaginaVotantes2(page: number, size: number, idVotacion: number, correoElectronico: string) {
    return this.http.get(this.apiUrl + "votante/obtenerVotantesParticipantesPaginado2?page=" + page + "&size=" + size + "&idVotacion=" + idVotacion + "&correoElectronico=" + correoElectronico);
  }

  subirArchivoVotantes(archivo, idVotacion, usuario) {
    const formData = new FormData();
    formData.append('archivo', archivo);
    formData.append('idVotacion', idVotacion);
    formData.append('usuario', usuario);
    return this.http.post(this.apiUrl + "votante/guardarArchivoVotantes", formData);
  }

}
